// extracted by mini-css-extract-plugin
export var chip = "_bd-0";
export var filterDropdown = "_bd-5";
export var filterItem = "_bd-6";
export var icon = "_bd-1";
export var removeButton = "_bd-3";
export var removeIcon = "_bd-4";
export var separator = "_bd-2";